import React, { useState } from "react";
import "./style.scss";

interface TooltipProps {
    direction?: "right" | "left" | "top" | "bottom";
    content?: string | React.ReactNode;
    delay?: number;
    children?: string | React.ReactNode;
    width?: number | string;
}

const Tooltip = (props: TooltipProps) => {
    const [active, setActive] = useState(false);
    const showTip = () => {
        setActive(true);
    };

    const hideTip = () => {
        setActive(false);
    };

    return (
        <div
            className="Tooltip-Wrapper"
            onMouseEnter={showTip}
            onMouseLeave={hideTip}
        >
            {props.children}
            {active && (
                <div
                    style={{ width: props.width }}
                    className={`Tooltip-Tip ${props.direction || "top"}`}
                >
                    {props.content}
                </div>
            )}
        </div>
    );
};

Tooltip.defaultProps = {
    direction: "right",
    width: 120,
};

export default Tooltip;
